/**
 * Strip query/hash and anything email-like from a string, so no PII leaks into
 * client error telemetry.
 *
 * Single source of truth: used on the browser side (the marketing site's
 * error-reporter) and re-applied server-side in the marketing Worker as
 * defence in depth. Keeping it here stops the two copies drifting.
 */
export function scrubPii(text: string): string {
  return text.replace(/[?#].*$/g, '').replace(/[\w.+-]+@[\w-]+\.[\w.-]+/g, '[email]');
}
